import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { AnvandareService } from "~app/common/services/anvandare.service";
import { ActivityViewModel } from "~app/pages/start/aktiviteter/ActivityViewModel";
import { ButtonComponent } from "../../button/button.component";
import { IconComponent } from "../../icon/icon.component";
import { InputComponent } from "../../input/input.component";
import { LabelComponent } from "../../label/label.component";
import { TextareaComponent } from "../../textarea/textarea.component";

@Component({
    selector: "rask-footer-activity-details",
    templateUrl: "./footer-activity-details.component.html",
    styleUrls: ["./footer-activity-details.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        InputComponent,
        FormsModule,
        LabelComponent,
        IconComponent,
        TextareaComponent,
        ButtonComponent
    ]
})
export class FooterActivityDetailsComponent {
    data: ActivityViewModel;
    modal = inject(NgbActiveModal);

    private readonly anvandareService = inject(AnvandareService);

    dismiss() {
        this.modal.close();
    }

    getStatusIcon(status: string) {
        return this.anvandareService.getActivityStatusIcon(status);
    }
}
